'use strict';

const endpoints = require('dibs-endpoints');
const tracking = require('dibs-tracking');
const PortfolioItemModel = require('bunsen/models/portfolio/PortfolioItemModel');

const PortfolioStore = require('../stores/PortfolioStore');
const User = require('../models/User');

module.exports = {
    removeItem(actionContext, payload) {
        const { ga } = payload;
        actionContext.dispatch('favorite:item:storage:remove', payload);

        tracking.trackEvent({
            category: 'item favoriting',
            action: 'item removed',
            label: ga.location,
            value: 1,
        });
    },

    saveItem(actionContext, payload) {
        const { ga } = payload;
        actionContext.dispatch('favorite:item:storage:save', payload);

        tracking.trackEvent({
            category: 'item favoriting',
            action: 'item added',
            label: ga.location,
            value: 1,
        });
    },

    syncLocal(actionContext) {
        const store = actionContext.getStore(PortfolioStore);
        const localItems = store.getLocalItems();
        let pk;

        for (pk in localItems) {
            if (localItems.hasOwnProperty(pk)) {
                const { vertical, createdDate } = localItems[pk];
                const portfolioModel = new PortfolioItemModel({
                    createdDate: new Date(createdDate).toISOString(),
                    item: {
                        id: pk,
                        apiType: vertical + 'Item',
                    },
                });

                portfolioModel.save(
                    {},
                    {
                        url: endpoints.portfolioAddItem(0, pk),
                        queries: {
                            userId: User.getUserId(),
                        },
                    }
                );
            }
        }

        actionContext.dispatch('favorite:item:storage:clear');
    },
};



// WEBPACK FOOTER //
// ./assets/js/global/actions/portfolioActions.es.js